<template>
    <MainContent :title="'Editar ' + role">
        <template v-slot:header>
            <h3 v-if="taquillero" class="card-title">Editar {{ role }}: {{ taquillero.name }}</h3>
        </template>
        <template v-slot:content v-if="taquillero && !sent">
            <div class="row">
                <div class="col-12">
                    <FormComponent :taquillero="taquillero" @terminado="editarTaquillero" :regions="regions"/>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormComponent from '@/components/backend/taquilleros/FormComponent';

    export default {
        props: ['taquillero_id', 'role'],
        data() {
            return {
                taquillero: null,
                sent: false,
                regions : [],
            }
        },
        created() {
            this.getTaquillero();
            this.getZonas();
        },
        computed: {
            place() {
                return this.$store.getters.getRecinto;
            },
        },
        methods: {
            getTaquillero : function() {
                const params = {
                    filters : {},
                    taquillero_id: this.taquillero_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.taquilleros.show'), params).then(res => {
                    this.taquillero = res.data.taquillero;
                });
            },
            editarTaquillero() {
                this.taquillero.filters = {};
                this.taquillero.taquillero_id = this.taquillero_id;
                this.sent = true;

                this.$store.dispatch(this.config.getVuexAlias('back.taquilleros.editar'), this.taquillero).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.taquilleros.show', params: { taquillero_id: this.taquillero_id, role: this.role } });
                });
            },
            getZonas() {
                this.loading = true;
                const params = {
                    filters: {
                        place_id: this.place.id
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.regions = res.data.map(({ id, name }) => ({ id, name }));
                    this.loading = false;
                });
            },
        },
        components: {
            MainContent, FormComponent
        }
    }
</script>
